import { useEffect } from 'react';
import { MediaPlayerInstance, useMediaRemote } from '@vidstack/react';
import { RefObject } from 'react';

/**
 * Hook to manage text track mode changes based on closed caption settings
 * @param playerRef - Ref to the MediaPlayerInstance
 * @param remote - Media remote instance from useMediaRemote
 * @param showClosedCaptions - Whether closed captions should be displayed
 * @param source - Media source (used as dependency)
 * @param track - Track URL (used as dependency)
 */
export const useTextTrackMode = (
  playerRef: RefObject<MediaPlayerInstance | null>,
  remote: ReturnType<typeof useMediaRemote>,
  showClosedCaptions: boolean,
  source: string | null,
  track?: string
): void => {
  useEffect(() => {
    if (remote && playerRef.current) {
      // Wait for tracks to be available before setting mode
      const timer = setTimeout(() => {
        const currentPlayer = playerRef.current;
        if (currentPlayer?.textTracks && currentPlayer.textTracks.length > 0) {
          remote.changeTextTrackMode(
            0,
            showClosedCaptions ? 'showing' : 'hidden'
          );
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [showClosedCaptions, remote, source, track, playerRef]);
};
